"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryMultiSelect = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("./index");

var _propTypes = require("prop-types");

var SecondaryMultiSelect = function SecondaryMultiSelect(props) {
  return /*#__PURE__*/_react.default.createElement(_index.SecondarySelect, props);
};

exports.SecondaryMultiSelect = SecondaryMultiSelect;
SecondaryMultiSelect.propTypes = {
  /* component logic props */
  isMulti: _propTypes.bool,
  closeMenuOnSelect: _propTypes.bool,
  hideSelectedOptions: _propTypes.bool,
  isClearable: _propTypes.bool
  /* styling modificators */

  /* classes */

};
SecondaryMultiSelect.defaultProps = {
  isMulti: true,
  closeMenuOnSelect: false,
  hideSelectedOptions: false,
  isClearable: false
};